(() => {
  let navbar = document.querySelector(".application-header-component");
  let navbarStyle = navbar.classList.contains('smile-navbar-light') ? 'smile-navbar-light' : 'smile-navbar-dark';
  let navbarLocation = navbar.offsetTop;
  let mobileNavButton = document.querySelector('.mobile-nav-button');

  mobileNavButton.addEventListener('click', () => {
    if (navbar.classList.contains('mobile-menu-show')) {
      navbar.classList.add('mobile-menu-hide');

      // Allow menu to fadeout before hiding
      setTimeout(() => {
        navbar.classList.remove('mobile-menu-show');
        navbar.classList.remove('mobile-menu-hide');
      }, 200);
    } else {
      navbar.classList.add('mobile-menu-show');
    }
  }, false);

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > navbarLocation) {
      navbar.classList.add('nav-shadow');
      navbar.classList.remove(navbarStyle);
    } else {
      navbar.classList.remove("nav-shadow");
      navbar.classList.add(navbarStyle);
    }
  }, false);
})();
